// Module
var code = "<!-- ko if: areRequestDetailsLoaded -->\r\n<!-- ko component: { name: requestComponentName, params: params } --><!-- /ko -->\r\n<!-- /ko -->";
// Exports
export default code;